<template>
  <div id="dashboard-page" class="animated fadeIn">
    <b-row>
      <!-- <b-col md="12"><module-menu></module-menu></b-col> -->
      <!--
      <b-col md="12">
        <b-card no-body class="pb-2 card-theme-primary">
          <b-form-row>
            <b-col>
              <h5 class="text-center mt-4"><b>Visitors</b> - Today</h5>
              <visitor-pie-chart></visitor-pie-chart>
            </b-col>
            <b-col class="position-relative">
              <h5 class="text-center mt-4"><b>Complaints</b> - All Time</h5>
              <div class="complain-tabs">
                <b-tabs pills end>
                  <b-tab title="By Status" active>
                    <complaint-pie-chart-by-status/>
                  </b-tab>
                  <b-tab title="By Category">
                    <complaint-pie-chart-by-category/>
                  </b-tab>
                </b-tabs>
              </div>
            </b-col>
            <b-col>
              <h5 class="text-center mt-4"><b>Panic Alert</b> - This Month</h5>
              <panic-pie-chart></panic-pie-chart>
            </b-col>
          </b-form-row>
        </b-card>
      </b-col>
      -->
      <b-col id="charts" md="12">
          <b-row>
            <b-col cols="4">
              <b-card class="card-theme-primary d-flex flex-grow">
                <h5 class="card-header text-left">Tickets <b>Today</b></h5>
                <visitor-pie-chart></visitor-pie-chart>
              </b-card>
            </b-col>
            <b-col cols="4">
              <b-card class="card-theme-primary d-flex flex-grow">
                <h5 class="card-header text-left">Tickets <b>This Month</b></h5>
                <visitor-pie-chart></visitor-pie-chart>
              </b-card>
            </b-col>
            <b-col cols="4">
              <b-card class="card-theme-primary d-flex flex-grow">
              <h5 class="card-header text-left"><b>Visited Sites</b> Today</h5>
                <panic-pie-chart></panic-pie-chart>
              </b-card>
            </b-col>
          </b-row>
      </b-col>
      <b-col cols='12'>
          <b-row>
            <!-- Booked Facility -->
            <b-col cols='12'>
              <b-card class="card-theme-primary">
                <h5 class="card-header text-left">Visited Sites for <b>Today</b></h5>
                <booking-list class="mt-2"></booking-list>
              </b-card>
            </b-col>
          </b-row>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import ModuleMenu from '@/views/index/moduleMenu'

// Visitors
import VisitorPieChart from '@/views/index/visitorPieChart'
import VisitorList from '@/views/index/visitorList'
import VisitorLog from '@/views/index/visitorLog'
import VisitorExceeded from '@/views/index/visitorExceeded'

// Facility Booking
import BookingList from '@/views/index/bookingList'

// Complaints
import complaintPieChartByStatus from '@/views/index/complaintPieChartByStatus'
import complaintPieChartByCategory from '@/views/index/complaintPieChartByCategory'
import ComplaintList from '@/views/index/complaintList'

// BCMessages
import BcmessageList from '@/views/index/bcmessageList'

// Panic
import PanicPieChart from '@/views/index/panicPieChart'

export default {
  name: 'menuIndex',
  components: {
    ModuleMenu,

    VisitorPieChart,
    VisitorList,
    VisitorLog,
    VisitorExceeded,

    BookingList,

    complaintPieChartByStatus,
    complaintPieChartByCategory,
    ComplaintList,

    BcmessageList,

    PanicPieChart
  },
  methods: {
    getVisExCount (val) {
      var badge = document.getElementById('visExceedBadge')
      if (val > 0) {
        badge.classList.remove('hidden')
      } else {
        badge.classList.add('hidden')
      }
      document.getElementById('visExceedCount').innerHTML = val
    }
  }
}
</script>

<style>
/* .complain-tabs {
  position: relative;
} */
.highcharts-container  {
  margin: auto;
}
.complain-tabs .tab-content {
  margin-top: 0;
  background: transparent;
  border: 0 solid #c2cfd6;
  padding-bottom: 32px;
}
.complain-tabs .tab-content .tab-pane {
  padding: 0 !important;
}
.complain-tabs ul {
  border-width: 0 !important;
  margin-bottom: 0;
  position: absolute;
  bottom: 0px;
  width: 100%;
  left: 0;
}
.complain-tabs ul li {
  border: 0 !important;
  width: 50%;
  text-align: center;
}
.complain-tabs ul li a {
  border-top: 1px solid #4dbd74 !important;
  padding-top: 5px !important;
  padding-bottom: 5px !important;
  font-size: 14px !important;
  color: #151b1e;
  border-bottom-right-radius: 0;
  border-bottom-left-radius: .25rem;
}
.complain-tabs ul li a.active {
  background: #4dbd74 !important;
  color: #fff !important;
}
.complain-tabs ul li:nth-child(2) a{
  border-bottom-right-radius: .25rem;
  border-bottom-left-radius: 0;
}
.tab-content {
  border-top-width: 0px !important;
}
#dashboard-page .vue-highcharts{
  margin-top: 43px !important;
}
#dashboard-page h5.card-header {
  margin: -20px -20px 0px !important;
  /* margin: -20px -20px 0px; */
  padding: 19px;
}
</style>



// WEBPACK FOOTER //
// src/views/Index.vue